import gql from 'graphql-tag';

const DEVICE_LIST = gql`
  query Query(
    $skip: Int!
    $limit: Int!
    $IMEI: String
    $stages: [String]
    $deviceType: [String]
    $firmwareVersion: [String]
    $hardwareVersion: [Int]
    $tags: [String]
    $softwareVersion: [Int]
    $batch: [String]
    $vendor: [String]
    $networkProvider: [String]
    $arambhDevice: Boolean
    $OTAFirmwareVersion: [String]
    $OTACompatible: Boolean
  ) {
    deviceList(
      skip: $skip
      limit: $limit
      IMEI: $IMEI
      stages: $stages
      deviceType: $deviceType
      firmwareVersion: $firmwareVersion
      tags: $tags
      hardwareVersion: $hardwareVersion
      softwareVersion: $softwareVersion
      batch: $batch
      vendor: $vendor
      networkProvider: $networkProvider
      arambhDevice: $arambhDevice
      OTAFirmwareVersion: $OTAFirmwareVersion
      OTACompatible: $OTACompatible
    ) {
      deviceList {
        generatedDatetime
        revoked
        customer
        sensors
        deviceSerialNo
        IMEI
        deviceType
        creator
        broker
        dataFrequency
        decommissioned
        lastAuthCheckedTime
        ssl
        deviceTypeName
        subType
        subTypeName
        stage
        hardwareVersion
        isBillable
        billingApplicableFrom
        initialCreditsAttached
        version
        status
        simNumber
        networkProvider
        tags
        OTACompatible
        firmwareVersion
        batch
        OTAFirmwareVersion
        arambhDevice
        vendor
        latitude
        longitude
        elevation
        device360 {
          customerName
          customerType
          plotName
          farmName
          crop {
            cropName
          }
          soil {
            type
            identifier
          }
        }
        pauseData {
          reason
          pausedOn
        }
        sensorData {
          lastSyncTime
          battery {
            value
            datetime
          }
          errorData
        }
      }
      count
    }
  }
`;

export default DEVICE_LIST;
